export const handleManifest = () => {
  const [theme, variant] = localStorage.getItem("theme")?.split("-") || ["forth", "light"];
  const isEdge =
    (["localhost", "10.0.2.2", "appdev.forthwithlife.co.uk", "devbuild.forthwithlife.co.uk"].includes(
      window.location.hostname,
    ) &&
      theme === "edge") ||
    window.location.hostname === "sportsbloodtests.co.uk";

  if (isEdge) {
    document.head.querySelectorAll("link[rel=manifest]")?.forEach(link => {
      link.href = "/edge-manifest.webmanifest";
    });
  }
};
